import React from 'react'
import Grid from '@material-ui/core/Grid'
import Guestonline from '../../Component/Interface/Guestonline'
import Nokeys from '../../Component/Interface/Nokeys'
import AllianceReseaux from '../../Component/Interface/AllianceReseaux'
import Abill from '../../Component/Interface/@bill'
import OTA from '../../Component/Interface/OTA'

import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'

export default (class extends React.Component {

  constructor(props) {
    super(props)
  }

  interfaces = {
    3061: {
      component: <Guestonline />
    },
    // 25: {
    //   component: <Nokeys/>
    // },
    3011: {
      component: <AllianceReseaux />
    },
    3040: {
      component: <Abill />
    },
    3001: {
      component: <OTA />
    }
  }

  state = {
    UserTabSelected: (Data.list(Constants.module.COMMUN, Constants.donnee.option) || []).findIndex(option => option.id > 3000 && option.id < 3999 && EurestoOption(option.id)),
    busGUID: Utils.uuidv4()
  }


  componentWillUnmount() {
    Bus.$off('donnees_annexes_interface', this.state.busGUID)
  }

  componentDidMount() {
    Bus.$on('donnees_annexes_interface', id => {
      this.setState({ UserTabSelected: id })
    }, this.state.busGUID)
  }

  render() {
    return <Grid container style={{ margin: 0, padding: 0, width: '100%', height: '100%' }} spacing={0}>
      <Grid item xs={12} key={this.state.UserTabSelected} style={{ margin: 0, padding: 0, width: '100%', height: '100%' }}>
        {
          this.state.UserTabSelected && this.interfaces[this.state.UserTabSelected] && this.interfaces[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/Interface/index.js